import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid } from '@material-ui/core'
import { scrollBar } from 'styles/theme'
import CopilotSettings from './CopilotSettings/CopilotSettings'

const useStyles = makeStyles(theme => ({
  patientCopilotRoot: {
    background: 'white',
    height: '100%',
    overflowY: 'scroll',
    padding: '20px 24px',
    ...scrollBar
  }
}))

const PatientCopilot = () => {
  const classes = useStyles()

  return (
    <Grid container direction="column" className={classes.patientCopilotRoot}>
      <Grid item>
        <CopilotSettings />
      </Grid>
    </Grid>
  )
}

export default PatientCopilot
